// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-rotate {
    top: 4.643em;
    right: auto;
    left: 0.5em;
}

.ol-touch .ol-control {
    font-size: 1.5em;
}

.ol-touch .ol-control button {
    font-size: 1.14em;
}

/* Global ol styles */
.ol-selectable {
    -ms-user-select: text;
    -moz-user-select: text;
    -webkit-user-select: text;
    user-select: text;
}

/* Control panes */

.control-pane {
    position: absolute;
    z-index: 10;
}

.control-pane--left {
    left: 16px;
}

.control-pane--top {
    top: 16px;
}

.control-pane--right {
    right: 16px;
}

.control-pane--bottom {
    bottom: 17px;
}

.control-pane--bottom.control-pane--right {
    right: 0;
    bottom: 0;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    background-color: rgba(255, 255, 255, 0.48);
    padding: 1px 2px 3px;
    overflow: hidden;
    line-height: 1;
}

.control-pane--bottom.control-pane--left {
    display: flex;
    align-items: center;
}

.control-pane .ol-control,
.control-pane .ol-scale-line {
    position: static;
    top: auto;
    top: -1px;
    right: auto;
    bottom: auto;
    left: auto;
    line-height: 1;
}

.control-pane--bottom .ol-control,
.control-pane--bottom .ol-scale-line {
    display: inline-block;
    vertical-align: bottom;
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.46);
    font-size: 10px;
}

.control-pane--bottom .ol-control:first-child,
.control-pane--bottom .ol-scale-line:first-child {
    margin-left: 0;
}

.control-pane--top .ol-control,
.control-pane--top .ol-scale-line {
    margin-top: 8px;
}

.control-pane--top .ol-control:first-child,
.control-pane--top .ol-scale-line:first-child {
    margin-top: 0px;
}

/* Map buttons */

.ol-control {
    background: none;
    padding: 0;
}

.ol-control button,
.ol-control button:active,
.ol-control button:focus {
    margin: 1px 0 0;
    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
    border-radius: 2px;
    background-color: #fff;
    padding-top: 0px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
}

.ol-control button {
    fill: var(--primary);
    cursor: pointer;
    color: var(--primary);
}

.ol-control.error button {
    fill: var(--error);
    color: var(--error);
}

.ol-control:first-child button {
    margin-top: 1px;
}

.control-pane--bottom .ol-control button {
    text-shadow: none;
}

.ol-control__icon {
    fill: inherit;
    color: inherit;
    font-size: 24px;
}

.ol-control:hover {
    background-color: transparent;
}

.ol-control button:hover {
    background-color: #f9fafb;
}

/* Rotate control */

.ol-compass {
    display: inline-block;
    font-weight: var(--ngw-text-font-weight-normal);
    font-size: 24px;
}

/* Scale line */

.ol-scale-line,
.control-pane .ol-scale-line {
    position: relative;
    top: 1px;
    background-color: transparent;
    padding: 0;
}

.ol-scale-line-inner {
    float: right;
    margin: 0;
    border-color: rgba(0, 0, 0, 0.46);
    color: rgba(0, 0, 0, 0.46);
}

/* Attribution */

.ol-attribution:not(.ol-collapsed) {
    background: transparent;
    height: auto;
    line-height: inherit;
}
.ol-attribution ul {
    padding: 0;
    color: inherit;
    line-height: 1;
    text-shadow: inherit;
}

.ol-attribution a {
    text-decoration: none;
}

.ol-attribution.ol-uncollapsible img {
    margin-top: -3px;
    margin-bottom: -1px;
    height: 14px;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/display/DisplayWidget.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,2CAA2C;IAC3C,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA,gBAAgB;;AAEhB;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;;;IAGI,eAAe;IACf,2CAA2C;IAC3C,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;;AAEnB;IACI,qBAAqB;IACrB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA,eAAe;;AAEf;;IAEI,kBAAkB;IAClB,QAAQ;IACR,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA,gBAAgB;;AAEhB;IACI,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".ol-rotate {\n    top: 4.643em;\n    right: auto;\n    left: 0.5em;\n}\n\n.ol-touch .ol-control {\n    font-size: 1.5em;\n}\n\n.ol-touch .ol-control button {\n    font-size: 1.14em;\n}\n\n/* Global ol styles */\n.ol-selectable {\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n}\n\n/* Control panes */\n\n.control-pane {\n    position: absolute;\n    z-index: 10;\n}\n\n.control-pane--left {\n    left: 16px;\n}\n\n.control-pane--top {\n    top: 16px;\n}\n\n.control-pane--right {\n    right: 16px;\n}\n\n.control-pane--bottom {\n    bottom: 17px;\n}\n\n.control-pane--bottom.control-pane--right {\n    right: 0;\n    bottom: 0;\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n    background-color: rgba(255, 255, 255, 0.48);\n    padding: 1px 2px 3px;\n    overflow: hidden;\n    line-height: 1;\n}\n\n.control-pane--bottom.control-pane--left {\n    display: flex;\n    align-items: center;\n}\n\n.control-pane .ol-control,\n.control-pane .ol-scale-line {\n    position: static;\n    top: auto;\n    top: -1px;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    line-height: 1;\n}\n\n.control-pane--bottom .ol-control,\n.control-pane--bottom .ol-scale-line {\n    display: inline-block;\n    vertical-align: bottom;\n    margin-left: 8px;\n    color: rgba(0, 0, 0, 0.46);\n    font-size: 10px;\n}\n\n.control-pane--bottom .ol-control:first-child,\n.control-pane--bottom .ol-scale-line:first-child {\n    margin-left: 0;\n}\n\n.control-pane--top .ol-control,\n.control-pane--top .ol-scale-line {\n    margin-top: 8px;\n}\n\n.control-pane--top .ol-control:first-child,\n.control-pane--top .ol-scale-line:first-child {\n    margin-top: 0px;\n}\n\n/* Map buttons */\n\n.ol-control {\n    background: none;\n    padding: 0;\n}\n\n.ol-control button,\n.ol-control button:active,\n.ol-control button:focus {\n    margin: 1px 0 0;\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n    border-radius: 2px;\n    background-color: #fff;\n    padding-top: 0px;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    text-decoration: none;\n}\n\n.ol-control button {\n    fill: var(--primary);\n    cursor: pointer;\n    color: var(--primary);\n}\n\n.ol-control.error button {\n    fill: var(--error);\n    color: var(--error);\n}\n\n.ol-control:first-child button {\n    margin-top: 1px;\n}\n\n.control-pane--bottom .ol-control button {\n    text-shadow: none;\n}\n\n.ol-control__icon {\n    fill: inherit;\n    color: inherit;\n    font-size: 24px;\n}\n\n.ol-control:hover {\n    background-color: transparent;\n}\n\n.ol-control button:hover {\n    background-color: #f9fafb;\n}\n\n/* Rotate control */\n\n.ol-compass {\n    display: inline-block;\n    font-weight: var(--ngw-text-font-weight-normal);\n    font-size: 24px;\n}\n\n/* Scale line */\n\n.ol-scale-line,\n.control-pane .ol-scale-line {\n    position: relative;\n    top: 1px;\n    background-color: transparent;\n    padding: 0;\n}\n\n.ol-scale-line-inner {\n    float: right;\n    margin: 0;\n    border-color: rgba(0, 0, 0, 0.46);\n    color: rgba(0, 0, 0, 0.46);\n}\n\n/* Attribution */\n\n.ol-attribution:not(.ol-collapsed) {\n    background: transparent;\n    height: auto;\n    line-height: inherit;\n}\n.ol-attribution ul {\n    padding: 0;\n    color: inherit;\n    line-height: 1;\n    text-shadow: inherit;\n}\n\n.ol-attribution a {\n    text-decoration: none;\n}\n\n.ol-attribution.ol-uncollapsible img {\n    margin-top: -3px;\n    margin-bottom: -1px;\n    height: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
